<template>
  <div class="col-span-2 grid grid-cols-1 md:grid-cols-4 gap-4">
    <line-chart class="col-span-2 bg-white overflow-hidden shadow rounded-lg mb-4 p-4 events-line-chart"
                height="400px"
                :chart-data="events"/>
    <data-table :entity="'client'"
                :columns="columns"
                :data="sortedResults.reverse()"
                :is-loading="loading"
                :disablePermissionChecks="true"
                :searchable="false"
                operations="refresh"
                class="col-span-2"
                ref="table">
      <template v-slot:date_month="{row}">
        {{$formatDate(new Date(year, row.date_month - 1, 1), 'MMM')}}
      </template>
    </data-table>
  </div>
</template>
<script>
import format from 'date-fns/format'
import LineChart from 'src/components/Charts/LineChart'
import ReportService from 'src/services/ReportService'
import orderBy from 'lodash/orderBy'
import get from 'lodash/get'

export default {
  components: {
    LineChart,
  },
  props: {
    dateFrom: {
      type: String,
      default: `${new Date().getFullYear()}-01-01`
    },
    dateTill: {
      type: String,
      default: format(new Date(), 'yyyy-MM-dd'),
    },
    job_board_id: {
      type: [String, Number],
      default: 2
    },
  },
  data () {
    return {
      year: new Date().getFullYear(),
      eventsTotals: {
        results: []
      },
      chartColors: ['#5145cd', '#31c48d', '#0694a2', '#F9703E', '#e02424'],
      loading: false,
    }
  },
  computed: {
    eventsReport () {
      const params = {
        model: 'events',
        group: 'job_boards,month',
        select: 'id,total,views,apply_starts,click_outs',
        date_range: 'custom',
        date_from: this.dateFrom,
        date_till: this.dateTill,
        sort: 'date_month',
        'where[job_board_id]': this.job_board_id,
      }
      if (this.job_board_id) {
        params['where[job_board_id]'] = this.job_board_id
      }
      return params
    },
    columns () {
      return [
        {
          label: this.$t('generic.month'),
          prop: 'date_month',
          sortable: true,
        },
        {
          label: this.$t('reports.click_outs'),
          prop: 'click_outs',
          sortable: true,
        },
        {
          label: this.$t('reports.apply_starts'),
          prop: 'apply_starts',
          sortable: true,
        },
        {
          label: this.$t('reports.apply_views'),
          prop: 'apply_views',
          sortable: true,
        },
      ]
    },
    sortedResults () {
      return orderBy(this.eventsTotals.results, 'date_format', 'asc')
    },
    events () {
      let validEvents = this.sortedResults

      const data = {
        labels: validEvents.map(r => this.$formatDate(new Date(this.year, r.date_month - 1, 1), 'MMM')),
        datasets: [
          {
            label: this.$t('reports.apply_views'),
            borderColor: '#0695A2',
            pointBackgroundColor: '#0695A2',
            data: validEvents.map(r => ({
              x: new Date(this.year, r.date_month - 1, 1),
              y: r.apply_views
            }))
          },
          {
            label: this.$t('reports.apply_starts'),
            borderColor: '#F9703E',
            pointBackgroundColor: '#F9703E',
            data: validEvents.map(r => ({
              x: new Date(this.year, r.date_month - 1, 1),
              y: r.apply_starts
            }))
          },
          {
            label: this.$t('reports.click_outs'),
            borderColor: '#5145cd',
            pointBackgroundColor: '#5145cd',
            data: validEvents.map(r => ({
              x: new Date(this.year, r.date_month - 1, 1),
              y: r.click_outs
            }))
          },
        ]
      }
      return data
    }
  },
  methods: {
    get,
    async getEventsReports () {
      try {
        this.loading = true
        const {data} = await ReportService.get(this.eventsReport)
        this.eventsTotals = data
        this.$emit('data-loaded', this.eventsTotals)
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    dateFrom () {
      this.getEventsReports()
    },
    dateTill () {
      this.getEventsReports()
    }
  },
  mounted () {
    this.getEventsReports()
  }
}
</script>
<style scoped>
.events-line-chart {
  max-height: 450px;
}
</style>
